import script from './panel-date-pick.vue_vue&type=script&lang.mjs';
export { default } from './panel-date-pick.vue_vue&type=script&lang.mjs';
import { render } from './panel-date-pick.vue_vue&type=template&id=78e07aa7&lang.mjs';

script.render = render;
script.__file = "packages/components/date-picker/src/date-picker-com/panel-date-pick.vue";
//# sourceMappingURL=panel-date-pick.mjs.map
